import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '@shared/shared.module';
import { NotificationsComponent } from './component/notifications/notifications.component';

@NgModule({
  declarations: [NotificationsComponent],
  imports: [
    CommonModule,
    SharedModule
  ],
  exports: [
    NotificationsComponent
  ]
})
export class NotificationsModule { }
